import { useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { getReportYears } from '../util/reportUtils';

export interface UseReportYearOptions {
  /** Number of years in the dropdown (default 5) */
  yearCount?: number;
}

/**
 * Shared hook for report list components that have a year filter.
 * Returns year state (from localStorage), years array, and a factory for handleYearChange.
 * Call makeHandleYearChange(parameters, setReload) after useTableSettings to get the handler.
 */
export function useReportYear(options: UseReportYearOptions = {}) {
  const { yearCount = 5 } = options;
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useLocalStorage<number>('report-year', currentYear);
  const years = getReportYears(yearCount);

  const makeHandleYearChange = useCallback(
    (
      parameters: React.MutableRefObject<Record<string, unknown> | null>,
      setReload: (value: Date) => void
    ) =>
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newYear = Number(e.target.value);
        setYear(newYear);
        if (parameters?.current) {
          parameters.current = { ...parameters.current, year: newYear };
        }
        setReload(new Date());
      },
    [setYear]
  );

  return { year, setYear, years, makeHandleYearChange, currentYear };
}
